export const DEFAULT_QUERY_PARAM_TABLE_IDENTIFIER = 'filters';

export enum FiltersWithSubfiltersMapping {
  PROMISE_TO_PAY = 'PROMISE_TO_PAY',
  REQUESTED_CALLBACK = 'REQUESTED_CALLBACK'
}

export enum FilterKeys {
  PROMISE_TO_PAY_TELE_CSA = 'promiseToPayDateTeleCsa',
  REQUESTED_CALLBACK_TELE_CSA = 'requestedCallbackDateTeleCsa',
  PROMISE_TO_PAY_FIELD_AGENT = 'promiseToPayDateFieldAgent',
  TELE_INTERACTION_STATUSES = 'teleInteractionStatuses'
}

export enum FilterType {
  DATE_TIME_PICKER = 'DateTimePickerFilter'
}

export const FILTERS_WITH_SUBFILTERS = [
  FiltersWithSubfiltersMapping.PROMISE_TO_PAY,
  FiltersWithSubfiltersMapping.REQUESTED_CALLBACK
];

export const subFilterMapping = new Map([
  [FiltersWithSubfiltersMapping.PROMISE_TO_PAY, FilterType.DATE_TIME_PICKER],
  [FiltersWithSubfiltersMapping.REQUESTED_CALLBACK, FilterType.DATE_TIME_PICKER]
]);

export const TeleInteractionStatusesFilterKey = new Map([
  [FiltersWithSubfiltersMapping.PROMISE_TO_PAY, FilterKeys.PROMISE_TO_PAY_TELE_CSA],
  [FiltersWithSubfiltersMapping.REQUESTED_CALLBACK, FilterKeys.REQUESTED_CALLBACK_TELE_CSA]
]);

export const FieldInteractionStatusesFilterKey = new Map([
  [FiltersWithSubfiltersMapping.PROMISE_TO_PAY, FilterKeys.PROMISE_TO_PAY_FIELD_AGENT]
]);

export const DATE_QUERY_PARAMS = [
  FilterKeys.PROMISE_TO_PAY_TELE_CSA,
  FilterKeys.REQUESTED_CALLBACK_TELE_CSA,
  FilterKeys.PROMISE_TO_PAY_FIELD_AGENT
];

export const MAX_WIDTH_SELECTED_FILTERS_DISPLAY = 800;
